import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["emailCheckbox", "emailTimingRow", "modeRadio", "timingLabel", "changeButton", "timingRadio"]

  // Whether Zmeniť has been used on this modal. The only piece of state not read
  // back off the DOM, because the DOM cannot tell "closed because the user never
  // asked" from "closed because the box is currently unticked".
  #openedByUser = false

  // Everything else is derived from the DOM, never remembered: the modal is not
  // destroyed when it closes, so a reopened one must show the same state the
  // server rendered rather than whatever the last visit left behind.
  connect() {
    this.#syncTimingLabel()
    this.emailToggled()
  }

  // Nothing about the timing means anything while the mail is not going out, so
  // an unticked box takes the whole block with it — the stated timing, Zmeniť
  // and the radios. Re-ticking restores exactly what was on screen before, and
  // Zmeniť stays retired once used: it must not offer to open an open row.
  emailToggled() {
    if (!this.hasEmailCheckboxTarget) return

    const sending = this.emailCheckboxTarget.checked
    if (this.hasTimingLabelTarget) this.timingLabelTarget.hidden = !sending
    if (this.hasEmailTimingRowTarget) this.emailTimingRowTarget.hidden = !(sending && this.#openedByUser)
    if (this.hasChangeButtonTarget) this.changeButtonTarget.hidden = !sending || this.#openedByUser
  }

  changeTiming() {
    if (!this.hasEmailTimingRowTarget) return

    this.#openedByUser = true
    this.emailTimingRowTarget.hidden = false
    if (this.hasChangeButtonTarget) {
      this.changeButtonTarget.setAttribute("aria-expanded", "true")
      this.changeButtonTarget.hidden = true
    }
  }

  timingChanged() {
    this.#syncTimingLabel()
  }

  modeChanged() {
    // Future: can be used to update UI based on mode selection
  }

  // The label restates the checked radio's own wording, so the two can never
  // disagree and the hour is never spelled out twice in JavaScript.
  #syncTimingLabel() {
    if (!this.hasTimingLabelTarget || this.timingRadioTargets.length === 0) return

    const checked = this.timingRadioTargets.find((radio) => radio.checked)
    if (!checked) return

    const label = checked.labels?.[0] || this.element.querySelector(`label[for="${checked.id}"]`)
    if (!label) return

    this.timingLabelTarget.textContent = ` · ${label.textContent.trim().toLocaleLowerCase()}`
  }
}
